// extracted by mini-css-extract-plugin
module.exports = {"marks_container":"DelimiterRenderer_marks_container__3TMFw","marks":"DelimiterRenderer_marks__1ZHUJ"};